module.exports = __webpack_public_path__ + "img/paw-claws.d9320991.svg";